import React from 'react';

import { useTranslation } from 'client/hooks';

import PopupWrapper from '../PopupWrapper';

import css from './ClosedRoomForHostPopup.module.scss';

interface Props {
  onCancel: () => void;
}

const ClosedRoomForHostPopup: React.FC<Props> = ({ onCancel }) => {
  const { translate } = useTranslation('popUps');

  return (
    <PopupWrapper onClose={onCancel}>
      <div className={css.container}>
        <div className={css.title}>
          <span>{translate('closedRoomForHost.title')}</span>
        </div>
      </div>
    </PopupWrapper>
  );
};

export default ClosedRoomForHostPopup;
